import locale from "@/helpers/locale";

const _mappingObj = {
  errCode001: locale("err.moviTicketNotFound"), //TODO: errCode just a MOCK data!!!
};

const _mappingHandler = errCode => {
  const __msg = _mappingObj(errCode) ? _mappingObj(errCode) : errCode;
  return __msg;
};

export default _mappingHandler;